/**
 * ButtonSection Schema
 * Schema-driven settings - Settings.jsx not needed
 */
export default {
  id: 'buttonsection',
  version: 1,
  title: 'Кнопка',
  description: 'Блок с кнопкой призыва к действию',
  icon: 'MousePointerClick',
  category: 'content',

  fields: [
    {
      group: 'Кнопка',
      fields: [
        {
          key: 'text',
          type: 'text',
          label: 'Текст',
          placeholder: 'Текст кнопки',
          defaults: { size: 'base', weight: 'medium', color: 'inherit' }
        },
        {
          key: 'link',
          type: 'link',
          label: 'Ссылка',
          placeholder: 'Выберите секцию или внешнюю ссылку'
        }
      ]
    },
    {
      group: 'Оформление',
      fields: [
        {
          key: 'variant',
          type: 'select',
          label: 'Вариант',
          mode: 'grid',
          columns: 2,
          options: [
            { value: 'primary', label: 'Основная' },
            { value: 'outline', label: 'Контурная' }
          ]
        },
        {
          key: 'size',
          type: 'select',
          label: 'Размер',
          mode: 'grid',
          columns: 4,
          options: [
            { value: 'sm', label: 'S' },
            { value: 'default', label: 'M' },
            { value: 'lg', label: 'L' },
            { value: 'xl', label: 'XL' }
          ]
        },
        {
          key: 'alignment',
          type: 'select',
          label: 'Выравнивание',
          mode: 'grid',
          columns: 3,
          options: [
            { value: 'left', label: 'Слева', icon: 'AlignLeft' },
            { value: 'center', label: 'Центр', icon: 'AlignCenter' },
            { value: 'right', label: 'Справа', icon: 'AlignRight' }
          ]
        },
        {
          key: 'fullWidth',
          type: 'checkbox',
          label: 'На всю ширину'
        }
      ]
    }
  ],

  // Дефолтные стили секции
  'x-styles': {
    paddingTop: 32,
    paddingBottom: 32
  },

  default: {
    text: { text: 'Перейти к секции' },
    variant: 'primary',
    size: 'default',
    link: '#section-1',
    alignment: 'center',
    fullWidth: false
  },

  migrate(data, fromVersion) {
    if (!fromVersion || fromVersion < 1) {
      // Convert old text format to new
      if (typeof data?.text === 'string') {
        return { ...this.default, ...data, text: { text: data.text } };
      }
      return { ...this.default, ...data };
    }
    return data;
  }
};
